export default "__VITE_ASSET__noMe7DpG__"